<template>
  <div class="box">
    <div class="detail">
      <div class="title">
        <img :src="icon" alt="" />
        <p>
          <span>{{ list.userName }}的{{ list.spname }}</span>
          <span v-if="list.spstatus === '1'" class="op-1">审批中</span>
          <span v-else-if="list.spstatus === '2'" class="op-2">已通过</span>
          <span v-else-if="list.spstatus === '3'" class="op-3">已驳回</span>
          <span v-else-if="list.spstatus === '4'" class="op-3">已撤销</span>
          <span v-else-if="list.spstatus === '6'" class="op-1">通过后撤销</span>
          <span v-else-if="list.spstatus === '7'" class="op-1">已删除</span>
          <span v-else-if="list.spstatus === '10'" class="op-1">已支付</span>
        </p>
      </div>
      <div class="con">
        <div v-for="item in info" :key="item.label">
          <p>{{ item.label }}</p>
          <p>{{ item.value }}</p>
        </div>
      </div>
      <div class="foot">
        <div>审批流程</div>
        <div class="footOne">
          <img src="../../assets/approval.svg" alt="" />
          <p>
            审批人·<span v-if="list.spstatus === '1'">审批中</span>
            <span v-else-if="list.spstatus === '2'">已通过</span>
            <span v-else-if="list.spstatus === '3'">已驳回</span>
            <span v-else-if="list.spstatus === '4'">已撤销</span>
            <span v-else-if="list.spstatus === '6'">通过后撤销</span>
            <span v-else-if="list.spstatus === '7'">已删除</span>
            <span v-else-if="list.spstatus === '10'">已支付</span>
          </p>
          <span class="qian">或签</span>
          <div></div>
        </div>
        <div class="footTwo">
          <p>
            <img :src="list.approverImg" alt="" />
            <span>{{ list.approverName }}</span>
          </p>
          <img v-if="list.spstatus === '2'" src="../../assets/ok.svg" alt="" />
          <span>
            <span v-if="list.spstatus === '1'">审批中</span>
            <span v-else-if="list.spstatus === '2'">已通过</span>
            <span v-else-if="list.spstatus === '3'">已驳回</span>
            <span v-else-if="list.spstatus === '4'">已撤销</span>
            <span v-else-if="list.spstatus === '6'">通过后撤销</span>
            <span v-else-if="list.spstatus === '7'">已删除</span>
            <span v-else-if="list.spstatus === '10'">已支付</span>
            <span v-if="list.approverTimeText">·</span>
            {{ list.approverTimeText }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis";
import { getToken } from "@/utils/cookie";
import moment from "moment";
export default {
  name: "detail",
  data() {
    return {
      label: [
        "审批编号",
        "提交时间",
        "所在部门",
        "异常类型",
        "职位类型",
        "签卡时间",
        "异常事由",
      ],
      value: [],
      info: [],
      icon: "",
      list: {},
      spno: "",
    };
  },
  created() {
    this.icon = this.$store.state.userInfo.icon;
    this.spno = this.$route.query.spno;
  },
  mounted() {
    this.getData();
  },
  methods: {
    //获取审批详情
    getData() {
      api.selectCardByEmpNo({ empNo: getToken() }).then((data) => {
        let info = data.data;
        let str = info.find((item) => {
          return item.spno === this.spno;
        });
        this.list = str;
        let item = moment(str.applytime).format("YYYY-MM-DD HH:mm:ss");
        this.value.push(
          str.spno,
          item,
          str.orgname,
          str.abnormaltypetext,
          str.positiontypetext,
          str.registrationcarddatetext,
          str.abnormalreason
        );
        for (let i = 0; i < this.label.length; i++) {
          this.info.push({ label: this.label[i], value: this.value[i] });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .detail {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .detail {
    width: 276px * $zoom;
  }
}
.box {
  display: flex;
  justify-content: center;
}
.detail {
  font-size: 18px * $zoom;
  min-height: 100vh;
  background: #f4f5f8;
  position: relative;
}
.title {
  background: #fff;
  display: flex;
  align-items: center;
  padding: 30px 15px;
  img {
    width: 80px;
    border-radius: 50%;
  }
  p {
    font-size: 30px;
    margin-left: 15px;
    font-weight: bold;
    .op-1 {
      color: #fff;
      background: rgb(212, 166, 13);
      margin-left: 15px;
      padding: 2px 7px;
      border-radius: 5px;
      font-weight: normal;
    }
    .op-2 {
      color: #fff;
      background: rgb(106, 177, 1);
      margin-left: 15px;
      padding: 1px 5px;
      border-radius: 5px;
      font-weight: normal;
    }
    .op-3 {
      color: #fff;
      background: rgb(240, 75, 34);
      margin-left: 15px;
      padding: 1px 5px;
      border-radius: 5px;
      font-weight: normal;
    }
  }
}
.con {
  background: #fff;
  margin-top: 15px;
  font-size: 28px;
  padding: 20px 20px 0px;
  div {
    display: flex;
    padding-bottom: 30px;
    p:nth-child(1) {
      color: #6a6a6b;
      width: 120px;
    }
    p:nth-child(2) {
      width: calc(100% - 160px);
      margin-left: 40px;
      word-wrap: break-word;
      padding-top: 2px;
    }
  }
}
.foot {
  background: #fff;
  margin-top: 15px;
  font-size: 28px;
  padding: 30px 20px;
  .footOne {
    display: flex;
    align-items: center;
    margin-top: 40px;
    img {
      width: 40px;
    }
    p {
      margin: 0 15px;
    }
    .qian {
      color: rgb(90, 183, 219);
      border: 1px solid rgb(90, 183, 219);
      font-size: 22px;
      padding: 1px 4px;
    }

    div {
      width: 0;
      height: 0;
      border-bottom: 12px solid #ccc;
      border-left: 12px solid white;
      border-right: 12px solid white;
      margin-left: 15px;
    }
  }
}
.footTwo {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  padding-left: 50px;
  position: relative;
  p {
    display: flex;
    align-items: center;
    img {
      width: 60px;
      border-radius: 50%;
      margin-right: 10px;
    }
  }
  & > span {
    color: #6a6a6b;
  }
  & > img {
    width: 30px;
    height: 30px;
    position: absolute;
    top: -10px;
    left: 90px;
    background: #fff;
  }
}
</style>
